import { AuthService } from '../services/auth/auth.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResumeGuard implements CanActivate {

  roles: string[] = [];

  constructor(private router: Router, private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = localStorage.getItem('accessToken');
    if (token) {
      const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
      if ((Math.floor((new Date).getTime() / 1000)) >= expiry) {
        //window.location.href = `/sign-in`;
        window.location.href = `/home`;
        return false;
      }


      if (this.isResumeAdmin())
      {
        return true; 
      } 
      else 
      {
        //window.location.href = `/sign-in`;
        window.location.href = `/home`;
        return false;
      }
      

    } else {
      let token: any = '';
      if (state.url.includes('token')) {
        token = state.url.split('token=').pop();
        if (token) {
          localStorage.setItem('accessToken', token);
          this.router.navigateByUrl('/');
          return true;
        } else {
          //window.open(`${environment.FE_URL}/sign-in?redirectURL=${environment.FE_URL}`, '_self');
          window.open(`${environment.FE_URL}/home`, '_self');
        }
      } else {
        //window.open(`${environment.FE_URL}/sign-in?redirectURL=${environment.FE_URL}`, '_self');
        window.open(`${environment.FE_URL}/home`, '_self');
      }
      return false;
    }

  }

  isResumeAdmin()
  {
    this.roles = JSON.parse(localStorage.getItem('roles') || '{}');

      for (let index = 0; index < this.roles.length; index++) {
        let element = this.roles[index];

        element = element.substring(0, element.length - 9).slice(4, element.length);

        if (atob(element) === "RESUME_ADMIN") {
          return true;
        }
      }

      return false;
  }

}
